class BrowserUserAgent {
  static is_chrome() {
    return navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
  }
  static is_ie() {
    return navigator.userAgent.toLowerCase().indexOf('msie') > -1;
  }
  static is_ie11() {
    return navigator.userAgent.toLowerCase().indexOf('trident') > -1;
  }
  static is_firefox() {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  }
  static is_safari() {
    return navigator.userAgent.toLowerCase().indexOf("safari") > -1;
  }
  static is_opera() {
    return navigator.userAgent.toLowerCase().indexOf("op") > -1;
  }
  static is_edge() {
    return navigator.userAgent.toLowerCase().indexOf("edge") > -1;
  }

}

export default BrowserUserAgent;


// WEBPACK FOOTER //
// ./src/utils/BrowserUserAgent.js